export default "__VITE_ASSET__BURjXQgy__"